import React, { Fragment } from 'react';
import { MAX_FILE_SIZE_IN_MB, tPrefix } from './constants';
import { ActionIconRotate, ButtonRoundTertiary, ParagraphTertiary, SpacerHorizontal, SpacerVertical, } from '@klarna/bubble-ui';
import { LoaderContainer, LoaderTitle, CenteredRow } from './styledComponents';
const strong = value => React.createElement("strong", null, value);
export const UploadingError = ({ uploadingFiles, uploadingError, t, loading, reUpload, }) => (React.createElement(React.Fragment, null, uploadingFiles.map(file => (React.createElement(Fragment, { key: file.lastModified },
    React.createElement(LoaderContainer, { error: uploadingError },
        React.createElement(LoaderTitle, null,
            React.createElement(ParagraphTertiary, { correctFootprint: true, error: true, overflowEllipsisWidth: "calc(50% - 40px)" }, file.name),
            React.createElement(CenteredRow, null,
                React.createElement(ParagraphTertiary, { correctFootprint: true, error: true, overflowEllipsisWidth: "calc(100% - 40px)" }, t(`${tPrefix}.errors.${uploadingError === 413 ? 'too_large_file' : 'general'}`, {
                    strong,
                    maxFileSizeMB: `${MAX_FILE_SIZE_IN_MB}`,
                })),
                React.createElement(SpacerHorizontal, { small: true }),
                React.createElement(ButtonRoundTertiary, { size: "small", loading: loading, onClick: reUpload, "aria-label": "retry upload" },
                    React.createElement(ActionIconRotate, null))))),
    React.createElement(SpacerVertical, { small: true }))))));
